module.exports = __webpack_public_path__ + "static/media/infohub-web.71aacc18.png";